import React, { type FC } from "react";
import MismatchTable from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/MismatchTable";
import mismatchDataTableDefinition from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/mismatch-data-table-definition";
import convertToMismatchTableFields, {
  orderMismatchTableByRuleSeverityAndAscendingItems,
} from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/mismatch-table-fields-extractor";
import type { ValidationModalRenderComponentProps } from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/ValidationModalRenderComponent";

const MismatchTableRenderComponent: FC<ValidationModalRenderComponentProps> = ({
  validationGroupId,
  validationUserActionsDropdownProps,
}) => {
  return (
    <MismatchTable
      validationGroupId={validationGroupId}
      dataTableDefinition={mismatchDataTableDefinition}
      dataTransformer={convertToMismatchTableFields}
      rowSorter={orderMismatchTableByRuleSeverityAndAscendingItems}
      validationUserActionsDropdownProps={validationUserActionsDropdownProps!}
    />
  );
};

export default MismatchTableRenderComponent;
